module.exports = __webpack_public_path__ + "img/qna.5d492143.png";